import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFlagsConfig } from '../../models';
import { SLICE_NAMES } from '../constants';

export const flagsConfigInitialState: IFlagsConfig = {
  isBlockingEnable: true,
  isContextMenusEnable: false,
  isPrivacyAgreed: false,
  showMotivationalImages: false,
  showWorkModeTimeFavIcon: false,
  slackDNDFocusMode: false,
  mandatoryButtonClicked: false,
  isExtensionSyncEnable: false,
  showSyncStatus: false,
  showPremiumOverlay: false,
  showWhatsNewOverlay: false,
  dontShowSlackFeatureOverlay: false,
  showAddSiteOverlay: false,
  displayPinToToolbarMessage: false,
};

const flagsConfigSlice = createSlice({
  name: SLICE_NAMES.FLAGS_CONFIG,
  initialState: flagsConfigInitialState,
  reducers: {
    updateFlagsConfig: (
      state,
      action: PayloadAction<Partial<IFlagsConfig>>
    ) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateFlagsConfig } = flagsConfigSlice.actions;

export const flagsConfigReducer = flagsConfigSlice.reducer;
